import { z } from "zod";

export const agreementAppSchema = () => {
  return z.object({
    agreement: z.number().min(1),
    name: z.string().min(1),
    slug: z.string().min(1),
    bundleIdentifier: z.string().min(1),
    app_id: z.string().optional(),
    appBaseUrl: z
      .string()
      .min(1)
      .refine(
        (val) => {
          try {
            const url = new URL(val);
            return url.protocol === "http:" || url.protocol === "https:";
          } catch {
            return false;
          }
        },
        { message: "Url inválida" }
      ),
    splash: z.any().refine((val) => {
      if (!val) return false;
      return true;
    }),
    icon: z.any().refine((val) => {
      if (!val) return false;
      return true;
    }),
    version: z.any().refine((val) => {
      if (!val) return false;
      return true;
    }),
    versionCode: z.any().refine((val) => {
      if (!val) return false;
      return true;
    }),
    iosPurchaseToken: z.string().optional().nullable(),
    androidPurchaseToken: z.string().optional().nullable(),
  });
};

export type AgreementAppFormValues = z.infer<
  ReturnType<typeof agreementAppSchema>
>;
